import "core-js/modules/es.function.name";
import HmacSHA256 from 'crypto-js/hmac-sha256';
import encHex from 'crypto-js/enc-hex';
export default {
  init: function init(_ref) {
    var appId = _ref.appId,
        identityVerificationSecret = _ref.identityVerificationSecret,
        user = _ref.user;

    if (document.getElementById('intercom')) {
      return;
    }

    var hash = HmacSHA256(user.id, identityVerificationSecret);
    var intercomHash = encHex.stringify(hash);
    var intercomSettings = JSON.stringify({
      app_id: appId,
      user_hash: intercomHash,
      user_id: user.id,
      name: user.name,
      email: user.email
    });
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'intercom';
    script.innerHTML = "\n      window.intercomSettings = ".concat(intercomSettings, ";\n      (function loadInterCom() {\n        const w = window;\n        const ic = w.Intercom;\n        if (typeof ic === 'function') {\n          ic('reattach_activator');\n          ic('update', w.intercomSettings);\n        } else {\n          const d = document;\n          var i = function() {\n            i.c(arguments);\n          };\n          i.q = [];\n          i.c = function(args) {\n            i.q.push(args);\n          };\n          w.Intercom = i;\n          const l = function() {\n            const s = d.createElement('script');\n            s.type = 'text/javascript';\n            s.async = true;\n            s.src = 'https://widget.intercom.io/widget/' + window.intercomSettings.app_id;\n            const x = d.getElementsByTagName('script')[0];\n            x.parentNode.insertBefore(s, x);\n          };\n\n          if (document.readyState === 'complete') {\n            l()\n          } else if (w.attachEvent) {\n            w.attachEvent('onload', l);\n          } else {\n            w.addEventListener('load', l, false);\n          }\n        }\n      })();\n    ");
    document.body.appendChild(script);
  }
};